import moment from 'moment';

export const dateFrom = () => {
  let bigDate = new Date();
  const od = new Date(bigDate.setDate(new Date().getDate() - 14));
  return  new Date(moment(od).format("YYYY-MM-DD")+" 00:00:00");
};

export const dateTo = () => {
  return new Date(moment().format("YYYY-MM-DD")+" 23:59:59");
};
